import { BorderRadius, Text } from '@enechain/ecloud-designsystem'

/**
 * 凡例スウォッチ — 折れ線 (line) または塗り (block) の凡例色を表示する。
 *
 * line variant は <svg><line> を使うため、lint 許可ファイルとして
 * eslint-config react-app.cjs の allowlist に登録済み。
 * 新たなアイコン用途の <svg> はここに追加せず DS icon を使うこと。
 */
export const LegendSwatch = ({
  color,
  label,
  isLine = false,
  dashed = false,
}: {
  color: string
  label: string
  isLine?: boolean
  dashed?: boolean
}): React.ReactElement => {
  return (
    // 凡例 (role="list") の 1 項目。支援技術とテストが凡例の並びを読めるようにする。
    <span
      role="listitem"
      style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
    >
      {isLine ? (
        <svg width="20" height="10">
          <line
            stroke={color}
            strokeDasharray={dashed ? '5 3' : undefined}
            strokeWidth={2}
            x1={0}
            x2={20}
            y1={5}
            y2={5}
          />
        </svg>
      ) : (
        <span
          style={{
            width: '14px',
            height: '14px',
            borderRadius: BorderRadius.radiiSm.value,
            background: color,
            display: 'inline-block',
          }}
        />
      )}
      {/* design `supply/supply-gap.html` の `#sg-legend .sg-leg` は
          `font-size: var(--font-size-md)` (14px) / `color: var(--text-high-emphasis)`。
          同 HTML のコメントも「ラベルは primary 色」 と書いており、 デザイナーの言う
          **primary 色 = 本文の黒 (highEmphasis)** を指す (2026-09-02 確認。
          `Text.accentPrimary` はリンク色なので当てない)。

          色は body の globalCss から既に highEmphasis を継承しているが、 **明示する**。
          継承頼みだと将来カードやヘッダに `color` が入った時に黙って崩れる
          (需要想定チャートの `ForecastChartLegend` が同じ理由で明示済み)。

          `~/constants/typography.ts` に凡例ラベル相当のロールは無い (`body` は md だが
          lineHeight 1.6 付き、 `caption`/`smallText` は sm、 `chartTypography.legend` は
          Recharts 用の raw px 体系で 12px)。 よってここは `fontSize` の直指定が正しい。 */}
      <Text as="span" color="Text.highEmphasis" fontSize="md">
        {label}
      </Text>
    </span>
  )
}
